/* global console */
import React from "react";
import type { LabelProps } from "@fluentui/react-label";
import type { SelectOnChangeData, SelectProps } from "@fluentui/react-select";
import { Label } from "@fluentui/react-label";
import { Select } from "@fluentui/react-select";
import { useTranslation } from "react-i18next";
import { SelectValueOption } from "../domain/SelectValueOption";
import { getFilterOptions } from "../../service/ArchibusApi";
import { FilterQueryParameters } from "../domain/FilterQueryParameters";
import { FilterOptions } from "../domain/FilterOptions";

interface SelectValueFilterProps {
  controlId: string;
  controlStyle: string;
  labelProps: LabelProps;
  labelText: string;
  labelStyle: string;
  selectOptions: SelectValueOption[];
  selectProps: SelectProps;
  selectedValue: string;
  disabled: boolean;
  setDisabled: (disabled: boolean) => void;
  buildQueryParameters: (value: string) => FilterQueryParameters;
  updateFilters: (data: FilterOptions) => void;
}

const SelectValueFilter = (props: SelectValueFilterProps): React.JSX.Element => {
  const { t } = useTranslation();
  const onChange = (_: any, data: SelectOnChangeData) => {
    props.setDisabled(true);
    getFilterOptions(props.buildQueryParameters(data.value))
      .then((data: FilterOptions) => props.updateFilters(data))
      .catch((reason: any) => {
        console.log(`Select ${props.labelText} failed.`);
        console.log(reason);
      })
      .finally(() => {
        props.setDisabled(false);
      });
  };

  // Skip rendering when no options are provided.
  if (props.selectOptions == null || props.selectOptions.length == 0) {
    return <></>;
  }

  return (
    <>
      <div className={props.labelStyle}>
        <Label htmlFor={props.controlId} {...props.labelProps}>
          {props.labelText}
        </Label>
      </div>
      <div className={props.controlStyle}>
        <Select
          id={props.controlId}
          value={props.selectedValue}
          onChange={onChange}
          disabled={props.disabled}
          {...props.selectProps}
        >
          {props.selectOptions.map((opt, index) => (
            <option key={index} value={opt.id}>
              {/* translate the 'any' option */}
              {opt.id == "" ? t("any") : opt.name}
            </option>
          ))}
        </Select>
      </div>
    </>
  );
};

export default SelectValueFilter;
